import * as types from './qualificationAwardAccreditation.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_QUALIFICATION_AWARD_ACCREDITATION,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_QUALIFICATION_AWARD_ACCREDITATION,
		payload,
	}),
	get: payload => ({
		type: types.GET_QUALIFICATION_AWARD_ACCREDITATION,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_QUALIFICATION_AWARD_ACCREDITATION,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_QUALIFICATION_AWARD_ACCREDITATION,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	clearData: () => ({
		type: types.CLEAR_DATA,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
